import type { IUseCase } from 'shared-kernel';
import type { IUserAdminRepository } from '../../domain/ports';
import type { UserFiltersParams, ListeUtilisateursResult } from '../dto/dtos';

export type ListerUtilisateursInput = UserFiltersParams;
export type ListerUtilisateursOutput = ListeUtilisateursResult;

export class ListerUtilisateursUseCase implements IUseCase<ListerUtilisateursInput, ListerUtilisateursOutput> {
  constructor(private readonly repository: IUserAdminRepository) {}

  async execute(input: ListerUtilisateursInput): Promise<ListerUtilisateursOutput> {
    const response = await this.repository.listerUtilisateurs(input);

    if (!response.succes || !response.data) {
      throw new Error(response.message || 'Erreur lors du chargement des utilisateurs');
    }

    return response.data;
  }
}
